import { type QuoteRequestStatus } from '@store/skeletor/quoteRequest/states/types';

const QUOTE_REQUEST_STATUS_LABELS: Record<QuoteRequestStatus, string> = {
  NEW: 'Nueva',
  IN_PROCESS: 'En proceso',
  SENT: 'Enviada',
  ABANDONED: 'Abandonada',
  DRAFT: 'Borrador',
  IN_VERIFICATION: 'En aprobación',
  IN_TREASURY: 'En tesorería',
  IN_DEPOSIT: 'En depósito',
  CLOSED: 'Cerrada',
  REJECTED: 'Rechazada',
};

const getQuoteRequestStatusLabel = (status: QuoteRequestStatus) => {
  return QUOTE_REQUEST_STATUS_LABELS[status] ?? status;
};

export { getQuoteRequestStatusLabel };
